import Link from 'next/link';

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <div>
          <div style={styles.logo}>UstamGelsin</div>
          <p style={styles.text}>Güvenilir ustaya ulaşmanın en hızlı yolu.</p>
        </div>

        <div style={styles.links}>
          <Link href="/hizmetler" style={styles.link}>Hizmetler</Link>
          <Link href="/basvuru" style={styles.link}>Usta Başvurusu</Link>
          <Link href="/iletisim" style={styles.link}>İletişim</Link>
        </div>
      </div>

      <div style={styles.copy}>© 2026 UstamGelsin. Tüm hakları saklıdır.</div>
    </footer>
  );
}

const styles: Record<string, React.CSSProperties> = {
  footer: {
    background: '#172033',
    color: 'white',
    marginTop: 60,
    padding: '34px 20px 20px',
  },
  inner: {
    maxWidth: 1180,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 24,
    flexWrap: 'wrap',
  },
  logo: {
    fontSize: 26,
    fontWeight: 900,
    color: '#ff8a65',
  },
  text: {
    color: '#d5d9e2',
  },
  links: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 600,
  },
  copy: {
    maxWidth: 1180,
    margin: '24px auto 0',
    color: '#b9c0cc',
    fontSize: 14,
  },
};
